<template>
  <div class="pay-result">
    <div class="pay-result-header">
      <img src="../assets/pay_success.png" alt />
      <div>支付成功</div>
    </div>
    <div class="pay-info">
      <div class="pay-info-item">
        <div>支付成功:</div>
        <div>&yen;{{payMoney}}</div>
      </div>
      <div class="pay-info-item">
        <div>变更单号:</div>
        <div>{{orderNo}}</div>
      </div>
      <div class="pay-hint">温馨提示:系统正在处理您的变更申请,具体进度可点击查看订单详情;如有其它疑问,欢迎致电联系95539 !</div>
      <div class="btn-group">
        <van-button @click="returnClick" round type="info" size="small">{{ btnBack }}</van-button>
        <van-button @click="lookOrderDescClick" round type="info" size="small">查看订单详情</van-button>
      </div>
    </div>
    <div v-show="showJoinmember" class="joinmember" @click="joinmember">
      <img class="joinmember_flight" src="../assets/joinmember_flight.png" alt />
      <img class="joinmember_text" src="../assets/joinmember_text.png" alt />
      <img class="joinmember_iocn" src="../assets/joinmember_iocn.png" alt />
    </div>
    <div class="pay-more-serve">
      <div class="line"></div>
      <span>更多服务 敬请期待</span>
    </div>
    <img class="serve-img" src="../assets/serves.png" alt />
  </div>
</template>

<script>
import queryString from "query-string";
import { payCallback } from "@/api/payResult";
import {
  upgradesList,
  upgradesDetails,
  msiteDetails,
  msiteList
} from "@/config/link";
import { setAllLoginRedirect } from "@/utils/common";

export default {
  name: "PayResult",
  data() {
    const { channel } = this.$route.params;
    const userInfo = window.sessionStorage.getItem("persist:emp")
      ? JSON.parse(JSON.parse(window.sessionStorage.getItem("persist:emp")).App)
          .userInfo
      : {};

    return {
      orderNo: "",
      payMoney: "",
      btnBack: channel === "upgrades" ? "返回升舱" : "返回可退改",
      showJoinmember:
        userInfo.memberType === "EM" && userInfo.identifyStatus === "N"
    };
  },
  methods: {
    // 返回可退改
    returnClick() {
      const { channel } = this.$route.params;
      if (channel === "upgrades") {
        window.location.href = upgradesList;
      }
      if (channel === "msite") {
        window.location.href = msiteList;
      }
    },
    // 查看订单详情
    lookOrderDescClick() {
      const { channel } = this.$route.params;
      if (channel === "upgrades") {
        window.location.href = `${upgradesDetails}?orderNo=${this.orderNo}`;
      }
      if (channel === "msite") {
        window.location.href = `${msiteDetails}?orderNo=${this.orderNo}`;
      }
    },
    // 活动链接
    joinmember() {
      window.location.href =
        "https://mskypearl.csair.com/msky/#/qrRegister?lang=zh&key=kyo/lPtDYhyZE8S4G59HzHxrEUpJqF7BafZmfbm/9r4ZV6P1ovbyO5uqxUFNzbvn";
    }
  },
  async created() {
    let encodeMsg = "",
      signMsg = "",
      orderNo = "",
      payMoney = "";
    if (window.location.href.indexOf("%3F") !== -1) {
      const url = window.location.href.replace("%3F", "&").replace("%3D", "=");
      const query = queryString.parse(url.slice(url.indexOf("?") + 1));
      encodeMsg = query.EncodeMsg;
      signMsg = query.SignMsg;
      orderNo = query.orderNo;
      payMoney = query.payMoney;
    } else {
      orderNo = this.$route.query.orderNo;
      payMoney = this.$route.query.payMoney;
      encodeMsg = this.$route.query.EncodeMsg;
      signMsg = this.$route.query.SignMsg;
    }

    if (encodeMsg && signMsg) {
      const data = await payCallback({
        encodeMsg,
        signMsg
      });
      if (data.error) {
        this.$popup(data.error.errorMsg);
        return false;
      }
      this.orderNo = data.orderNo || orderNo;
      this.payMoney = data.payMoney || payMoney;
    }
  },
  mounted() {
    const { channel } = this.$route.params;
    if (channel === "upgrades") {
      setAllLoginRedirect(upgradesList);
    }
    if (channel === "msite") {
      setAllLoginRedirect(msiteList);
    }
  }
};
</script>

<style lang="less" scoped>
@import "../style/constant.less";
@import "../style/general.less";
.pay-result {
  background-color: #fff;
  &-header {
    text-align: center;
    > img {
      height: 40px;
      width: 40px;
      margin: 36px 0 14px;
    }
    > div {
      font-size: 25px;
      color: #000;
      opacity: 0.8;
      font-weight: 600;
    }
  }
  .pay-info {
    margin: 30px 21px 0;
    &-item {
      color: #000;
      opacity: 0.8;
      margin-bottom: 13px;
      font-size: @font-sm-size;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      > div:last-child {
        flex: 1;
        min-width: 0;
        text-align: right;
        @font-overflow();
      }
    }
    .pay-hint {
      border-top: 1px solid #ddd;
      padding-top: 13px;
      font-size: @font-xms-size;
      color: #000;
      opacity: 0.6;
    }
    .btn-group {
      text-align: center;
      margin-bottom: 28px;
      > button {
        width: 130px;
        height: 36px;
        font-size: @font-sm-size;
        margin: 23px 16px 0;
      }
    }
  }
  .pay-more-serve {
    background-color: #e9f0f5;
    height: 40px;
    line-height: 40px;
    position: relative;
    text-align: center;
    > .line {
      background-color: #ddd;
      height: 1px;
      padding: 0;
      position: absolute;
      margin: auto;
      top: 0;
      bottom: 0;
      left: 50px;
      right: 50px;
      z-index: 1;
    }
    > span {
      font-size: @font-xxs-size;
      color: #8b9097;
      background-color: #e9f0f5;
      position: relative;
      z-index: 2;
      padding: 0 20px;
    }
  }
  .serve-img {
    width: 100%;
  }
}
.joinmember {
  background: url("../assets/joinmember_bg.png") no-repeat;
  background-size: 100% auto;
  border-radius: 0.16rem;
  margin: 0 15px;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  .joinmember_flight {
    width: 60px;
    margin-right: 10px;
  }
  .joinmember_text {
    width: 50%;
  }
  .joinmember_iocn {
    width: 40px;
    margin-left: 10px;
  }
}
</style>
